import { computed, onUnmounted, ref } from 'vue';

export function useAbort() {
  const abortController = ref(new AbortController());

  const signal = computed(() => abortController.value.signal);

  function abort(reason = 'An interrupt was called') {
    abortController.value.abort(reason);
    abortController.value = new AbortController();
  }

  onUnmounted(() => abortController.value.abort('The component has been destroyed'));

  return {
    signal,
    abort,
  };
}
